import { MemoizedSelector, createSelector } from "@ngrx/store";
import { Dictionary } from '@ngrx/entity';

import { MediaState } from "../states";
import { mediaAdapter } from '../adapters/media.adapter';
import { MediaEntity } from '../entities';
import { MediaFeatureState } from '../states';
import { selectMediaFeatureState } from "./media-feature.selectors";
import { MediaViewModel } from "../models";

export const selectMediaState: MemoizedSelector<object, MediaState> = createSelector(selectMediaFeatureState, (state: MediaFeatureState) => state.media);

const {
    selectIds: selectIds,
    selectEntities: selectMediaEntities,
    selectAll: selectAll,
    selectTotal: selectTotal
} = mediaAdapter.getSelectors(selectMediaState);


// -------------[Mapping Functions]------------- 
const getLoading = (state: MediaState): boolean => state.loading;
const getLoaded = (state: MediaState): boolean => state.loaded;
const getAllMedia = (entities: Array<MediaEntity>, state: MediaState) => {
    let result = entities.map((entity) => new MediaViewModel(entity));
    // Alsway to put item created on top
    // if (state.createdMediaId > 0) {
    //     const createdMedia = result.splice(result.findIndex(fi => fi.id === state.createdMediaId), 1);
    //     result = [...createdMedia, ...result];
    // }
    return result;
}
const getNextUrl = (state: MediaState): string => state.nextUrl;
const getCreatedMediaId = (state: MediaState): number => state.createdMediaId;
const getMediaById = (entities: Dictionary<MediaEntity>, mediaId:any) => {
    if(typeof mediaId === 'string'){
        mediaId = mediaId.split(',')
    }
if( mediaId && mediaId.length){
    var storeoBj = [];
    mediaId.forEach((item)=>{
    let obj = new MediaViewModel(entities[+item])
    storeoBj.push(obj)
})
return storeoBj
}
else {
    return null
}
}
// -------------[Public Selectors]-------------
export const selectLoaded: MemoizedSelector<object, boolean> = createSelector(selectMediaState, getLoaded);
export const selectLoading: MemoizedSelector<object, boolean> = createSelector(selectMediaState, getLoading);
export const selectMedia: MemoizedSelector<object, Array<MediaViewModel>> = createSelector(selectAll, selectMediaState, getAllMedia);
export const selectNextUrl: MemoizedSelector<object, string> = createSelector(selectMediaState, getNextUrl);
export const selectCreatedMediaId: MemoizedSelector<object, number> = createSelector(selectMediaState, getCreatedMediaId);
export const selectMediaById = createSelector(selectMediaEntities, getMediaById)
